import EditImpactContainer from "../containers/EditImpactContainer";

const EditImpactPage = () => {
  return (
    <EditImpactContainer />
  );
};

export default EditImpactPage;
